export const NO_MATCH_FOUND = 'No matches';
export const REVISE_SEARCH = 'Please revise your search or';
export const BROWSE_LOCATION = 'browse for a location';
export const KEEP_TYPING = 'Keep typing to refine search';
